import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import styles from './Auth.module.css';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password,  setPassword]  = useState('');
  const [confirm,   setConfirm]   = useState('');
  const [loading,   setLoading]   = useState(false);
  const [error,     setError]     = useState('');
  const [ready,     setReady]     = useState(false);

  useEffect(() => {
    // Supabase fires an event when the reset token in the URL is detected
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setReady(true);
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 8)  { setError('Password must be at least 8 characters.'); return; }
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    if (error) { setError(error.message); setLoading(false); return; }
    await supabase.auth.signOut();
    navigate('/login?reset=success');
  };

  if (!ready) return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>Run<span>Staff</span>Run</div>
        <p className={styles.sub}>Verifying your reset link...</p>
      </div>
    </div>
  );

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>Run<span>Staff</span>Run</div>
        <h1 className={styles.heading}>Set a new password</h1>
        <p className={styles.sub}>Choose a strong password for your account.</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          {error && <div className="error-msg">{error}</div>}
          <div className="form-group">
            <label>New password</label>
            <input
              className="form-input"
              type="password" required
              placeholder="At least 8 characters"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Confirm new password</label>
            <input
              className="form-input"
              type="password" required
              placeholder="••••••••"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
            />
          </div>
          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? 'Updating...' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
